import { call, fork, put, take } from 'redux-saga/effects';
import { authError, loginStart, loginSuccess, checkAuthStart, checkAuthFailed } from '../actions';
import { getCurrentUser, login } from '../api';
import { authStorage } from '../../services/security/authStorage';

function* watchLoginSaga() {
  while (true) {
    const action = yield take('LOGIN_REQUEST');
    yield fork(handleLogin, action);
    yield take(['AUTH_ERROR', 'SIGNOUT_SUCCESS', 'LOGIN_SUCCESS']);
  }
}
function* watchCheckAuthSaga() {
  yield take('CHECK_Auth_REQUEST');
  yield call(handleCheckAuth);
}
function* handleLogin(action) {
  const reqBody = action.payload;
  yield put(loginStart());
  let res;
  let issuedToken = null;
  try {
    const { data } = yield call(login, reqBody);
    if (data && data.auth_token) {
      issuedToken = data.auth_token;
      authStorage.setAuthToken(issuedToken);
      //@ts-ignore
      if (data.auth_token) {
        const { data: currentUser } = yield call(getCurrentUser);
        yield put(loginSuccess({ currentUser, userPermissions: currentUser.permissions }));
      } else {
        authStorage.clearAuthToken();
        throw new Error('invalid_user');
      }
    } else {
      console.log('res error', res);
      throw new Error('unknown_error');
    }
  } catch (error) {
    // Only clear the token we just issued — never a newer concurrent login token
    if (!issuedToken || authStorage.getAuthToken() === issuedToken) {
      authStorage.clearAuthToken();
    }
    if (error.response) {
      if (error.response.status === 401) {
        yield put(authError('unauthorized'));
      } else {
        yield put(authError(error.message || 'unknown_error'));
      }
    } else {
      yield put(authError(error.message));
    }
  }
}
function* handleCheckAuth() {
  yield put(checkAuthStart());
  const token = authStorage.getAuthToken();
  if (!token) {
    yield put(checkAuthFailed('no token'));
    return;
  }

  try {
    // Migrate any legacy sessionStorage token into localStorage
    authStorage.setAuthToken(token);
    const { data: currentUser } = yield call(getCurrentUser);
    yield put(loginSuccess({ currentUser, userPermissions: currentUser.permissions }));
  } catch (error) {
    // Do not wipe a newer token from an in-flight Office 365 login
    if (authStorage.getAuthToken() === token) {
      authStorage.clearAuthToken();
    }
    yield put(checkAuthFailed('invalid token'));
  }
}
export { watchLoginSaga, watchCheckAuthSaga };
